import { controlPanelShell as fdy } from "./foundry-parts.generated";
/**
 * @fileoverview SettingsSidebar — Module-internal left rail with labeled
 * navigation. Distinct from the global Shell Sidebar and from Carbon's
 * workspace bar. Composed of stacked SettingsSidebarSection blocks.
 *
 * Foundry mapping: `control-panel-shell__settings-sidebar`.
 */

import type { ReactNode } from "react";

interface SettingsSidebarProps {
  children: ReactNode;
  className?: string;
}

export function SettingsSidebar({ children, className }: SettingsSidebarProps) {
  return (
    <ul data-testid="settings-sidebar" /*
        BOTH CLASSES, ON ONE ELEMENT. The rail used to be this ul inside a
        `div.__settings-sidebar__` supplied by the page. The capture has a
        single element wearing `__settings-sidebar__` and `__sidebar__`; the
        extra div shifted every following sibling in the diff.
      */
      className={[fdy["settings-sidebar"], fdy["sidebar"], className].filter(Boolean).join(" ")}>
      {children}
    </ul>
  );
}
